import styled from 'styled-components';

export const BadgeContainer = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const Badge = styled.span`
  position: absolute;
  top: -4px;
  right: -4px;
  background: ${({ theme }) => theme.colors.error || '#ff0000'};
  color: white;
  border-radius: 10px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 1;
  
  /* Animation for new notification */
  animation: pulse 0.3s ease-in-out;
  
  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }
`;

export const OfflineIndicator = styled.span`
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  background: ${({ theme }) => theme.colors.warning || '#ffa500'};
  border: 2px solid ${({ theme }) => theme.colors.bg1 || '#ffffff'};
  border-radius: 50%;
  z-index: 1;
`;
